export default class Mainvisual {
    constructor() {
        this.mvVersions = document.querySelectorAll('.js-mv_version');
        this.activeIndex = 0;
        this.prevIndex = 2;
        this.nextIndex = 1;
        this.maxIndex = 2;
        this.init();
    }

    init() {
        this.eventBind();
    }

    eventBind() {
        setInterval(() => {
            this.mvVersions[this.activeIndex].classList.add('-end');
            this.changeActiveIndex();
            this.changePrevIndex();
            this.changeNextIndex();
            this.mvVersions[this.nextIndex].classList.remove('-active', '-end');
            this.mvVersions[this.activeIndex].classList.add('-active');
        }, 5000);
    }

    changeActiveIndex() {
        if (this.activeIndex === this.maxIndex) {
            this.activeIndex = 0;
        } else {
            this.activeIndex++;
        }
    }

    changePrevIndex() {
        if (this.prevIndex === this.maxIndex) {
            this.prevIndex = 0;
        } else {
            this.prevIndex++;
        }
    }

    changeNextIndex() {
        if (this.nextIndex === this.maxIndex) {
            this.nextIndex = 0;
        } else {
            this.nextIndex++;
        }
    }
}
